__turbopack_context__.v({
  "desktopTable": "wDua7G_desktopTable",
  "glyph": "wDua7G_glyph",
  "head": "wDua7G_head",
  "headerCell": "wDua7G_headerCell",
  "heading": "wDua7G_heading",
  "inner": "wDua7G_inner",
  "mobileStickyHeader": "wDua7G_mobileStickyHeader",
  "mobileTable": "wDua7G_mobileTable",
  "section": "wDua7G_section",
  "stickyHeader": "wDua7G_stickyHeader",
  "subhead": "wDua7G_subhead",
});
